import {
  BulkUpdateUploadDocumentTaskFilesDocument,
  BulkUpdateUploadDocumentTaskFilesMutationVariables,
  GetUploadDocumentTaskFilesDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'

export const useBulkUpdateUploadDocumentTaskFiles = () => {
  const [bulkUpdateFiles] = useMutation(BulkUpdateUploadDocumentTaskFilesDocument, {
    extractorFn: (data) => data.tasksMutations.bulkUpdateTasksUploadDocumentTaskFile,
  })

  const createUploadDocumentTaskFile = async (
    variables: BulkUpdateUploadDocumentTaskFilesMutationVariables
  ) => {
    const rawResult = await bulkUpdateFiles({
      variables,
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: GetUploadDocumentTaskFilesDocument,
          variables: {
            taskId: variables.taskId,
            folderId: variables.folderId,
          },
        },
      ],
    })

    const result = handleResult(rawResult, (errors) => {
      throw 'Could not update files: ' + JSON.stringify(errors)
    })

    if (!result.success) {
      throw 'Could not update files: ' + JSON.stringify(result.errors)
    }

    return result.data.uploadDocumentTaskFiles
  }

  return createUploadDocumentTaskFile
}
